/**
 * Page Visibility API helpers with iPad / iOS Safari compatibility.
 * Older Safari may only support webkit-prefixed document.webkitHidden and webkitvisibilitychange;
 * modern Safari and iOS 13+ support the standard API.
 * @see https://developer.mozilla.org/en-US/docs/Web/API/Page_Visibility_API
 */

function getHiddenProp() {
    if (typeof document === 'undefined') return null;
    if (typeof document.hidden !== 'undefined') return 'hidden';
    if (typeof document.webkitHidden !== 'undefined') return 'webkitHidden';
    return null;
}

function getVisibilityChangeEventName() {
    if (typeof document === 'undefined') return 'visibilitychange';
    if (typeof document.hidden !== 'undefined') return 'visibilitychange';
    if (typeof document.webkitHidden !== 'undefined') return 'webkitvisibilitychange';
    return 'visibilitychange';
}

const hiddenProp = getHiddenProp();
const visibilityChangeEvent = getVisibilityChangeEventName();

/**
 * Returns true if the page is considered hidden (tab in background, app switched away on iPad, etc.).
 * Works on iPad Safari including older versions that use webkitHidden.
 */
export function isPageHidden() {
    if (typeof document === 'undefined' || !hiddenProp) return false;
    return Boolean(document[hiddenProp]);
}

/**
 * Returns true if the page is visible to the user.
 */
export function isPageVisible() {
    return !isPageHidden();
}

/**
 * Event name to use for visibility change (standard or webkit-prefixed for older Safari).
 * Use with document.addEventListener(visibilityChangeEvent, handler).
 */
export function getVisibilityChangeEvent() {
    return visibilityChangeEvent;
}
